const DAY = 86400000;
export const dateKey = value => value.toISOString().slice(0, 10);
export function todayInZone(timeZone, now = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-CA", { timeZone: timeZone || undefined, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now);
    const get = type => parts.find(part => part.type === type).value;
    return `${get("year")}-${get("month")}-${get("day")}`;
  } catch { return dateKey(now); }
}
export function presetRange(preset, today) {
  if (preset === "today") return { start: today, end: today };
  const end = new Date(`${today}T00:00:00Z`);
  const start = preset === "month" ? `${today.slice(0, 7)}-01`
    : dateKey(new Date(end.getTime() - (preset === "7" ? 6 : 29) * DAY));
  return { start, end: today };
}
export function validRange({ start, end }) {
  const first = new Date(`${start}T00:00:00Z`), last = new Date(`${end}T00:00:00Z`);
  return /^\d{4}-\d{2}-\d{2}$/.test(start) && /^\d{4}-\d{2}-\d{2}$/.test(end)
    && Number.isFinite(first.getTime()) && Number.isFinite(last.getTime())
    && dateKey(first) === start && dateKey(last) === end
    && last >= first && (last - first) / DAY < 366;
}
export const formatDay = (value, locale, options = { day: "numeric", month: "short" }) =>
  new Date(`${value}T12:00:00Z`).toLocaleDateString(locale || "pt", { ...options, timeZone: "UTC" });
